import type { ServerApiError } from '@wellesley/openapi/helpers'

interface HelperProps extends RequestInit {
  url: string
}

const safeFetch = async <T>({ url, ...props }: HelperProps) => {
  const request = await fetch(url, props)

  if (!request.ok) {
    throw new Error(request.statusText)
  }

  if (props.method === 'PUT') return // no read body.json() for upload file to bucket call

  const response = (await request.json()) as T | ServerApiError
  const errorResponse = response as ServerApiError

  if (errorResponse.errorCode) {
    throw new Error(errorResponse.message)
  }

  const data = response as T

  return data
}

export default safeFetch
